
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      mission: "Our Mission",
      certifications: "Certifications",
      news: "News",
      contact: "Contact",
    },

    news: {
      badge: "LATEST NEWS",
      title: "News & Updates",
      subtitle: "The latest from FrontSpace Cyber Academy.",
      readMore: "Read More",
      empty: "No news yet. Check back soon.",
    },

    hero: {
      badge: "Elite digital technology",
      title: "TRAIN",
      titleAccent: " BUILD",
      titleEnd: "SECURE",
      subtitle: `From cybersecurity and custom digital solutions to practical technology education, Frontspace helps you move confidently into the digital future.`,
      cta: "Apply Now",
      learnMore: "Learn More",
      stat1: "1",
      stat1Label: "Connected Ecosystem",
      stat2: "24/7",
      stat2Label: "Security Operations",
      stat3: "4",
      stat3Label: "Training modules",
      stat4: "100%",
      stat4Label: "Custom Built",
      scroll: "Scroll Down",
    },

    features: {
      badge: "WHY FRONTSPACE?",
      title: "Built for the Real World",
      subtitle:
        "Created to help people and businesses develop skills, secure systems, and build new technology.",
      items: [
        {
          title: "Train",
          desc: "Build practical skills and prepare for real world opportunities.",
        },
        {
          title: "Build",
          desc: "Create custom digital solutions designed around the way your business works.",
        },
        {
          title: "Secure",
          desc: "Protect your business with proactive cybersecurity and 24/7 security operations",
        },
      ],
    },

    syllabus: {
      badge: "THE 4-IN-1 ZERO TO HERO PROGRAM",
      title: "THE 4-IN-1 ZERO TO HERO PROGRAM",
      desc1:
        "This is it—the ultimate way to become a cybersecurity expert. We've combined 4 powerful courses into 1 massive program to give you everything you need in one place.",
      desc2:
        "Whether you are a total beginner or looking to level up, this is the big deal you've been waiting for.",
      desc3:
        "This is the fastest, most powerful way to master the field and change your career forever.",
      instruction:
        "CLICK THE 4 MODULES BELOW TO OPEN THEM AND CHECK OUT YOUR NEW PATH:",
      modules: [
        { name: "CERTIFIED CTI ANALYST", key: "cti" },
        {
          name: "CERTIFIED CYBERSECURITY ANALYST",
          key: "analyst",
        },
        {
          name: "CERTIFIED CYBERSECURITY ASSOCIATE",
          key: "associate",
        },
        { name: "CERTIFIED SOC ANALYST", key: "soc" },
      ],
      modalTitle: "Download Syllabus",
      modalDesc: "Fill in your details to download the syllabus.",
      formName: "Full Name",
      formEmail: "Email Address",
      formPhone: "Phone Number",
      formSubmit: "Download Syllabus",
      formSending: "Sending...",
      formSuccess: "Your syllabus is downloading!",
      formError: "Something went wrong. Please try again.",
    },

    about: {
      badge: "ABOUT FRONTSPACE",
      title: "Technology, security, and expertise-connected.",
      p1: "Frontspace is a technology company built around three capabilities:Train. Build. Secure.",
      p2: "Businesses are transforming how they operate. New technologies are changing entire industries. Cyber threats are becoming more sophisticated. And the demand for people who understand technology continues to grow.Frontspace exists at the intersection of these changes.",
      p3: "We bring together education, digital engineering, and cybersecurity to help people and organizations navigate this environment with confidence. We help individuals develop practical cybersecurity skills, help businesses build custom digital solutions, and help organizations protect their digital environments through professional cybersecurity services.Our goal is simple: Make technology more useful, more accessible, and more secure.",
      alignedTitle: "Aligned with NIST-NICE",
      alignedDesc:
        "Curriculum mapped to the NICE Framework — the global industry standard.",
      salaryTitle: "Competitive Entry-Level Salary",
      salaryDesc:
        "Cybersecurity professionals are in high demand, leading to starting salaries that outpace many other tech roles.",
      labsTitle: "100+ Hands-On Exercises",
      labsDesc:
        "Spend most of your time in virtual labs performing real-world security tasks.",
      vetTitle: "Industry Vetted Content",
      vetDesc:
        "Course material is regularly reviewed by active security experts.",
      roles: {
        title: "Eligible Roles After Graduation",
        items: [
          "Security Analyst",
          "SOC Analyst",
          "CTI Analyst",
          "Penetration Tester",
          "Incident Responder",
          "Security Engineer",
        ],
      },
    },

    mission: {
      badge: "OUR MISSION",
      title: "Securing the Digital Future",
      subtitle:
        "We bridge the gap between zero experience and professional cybersecurity excellence",
      visionTitle: "Our Vision",
      visionContent:
        "To become the world's leading pathway for individuals entering the cybersecurity field — creating a global network of skilled professionals.",
      missionTitle: "Our Mission",
      missionContent:
        "To democratize access to cybersecurity education by delivering elite military training methodologies to anyone with the will to learn, regardless of background.",
      valuesTitle: "Core Values",
      values: [
        {
          title: "Excellence",
          desc: "We maintain the highest standards in every aspect of our training program.",
        },
        {
          title: "Innovation",
          desc: "Our curriculum continuously evolves with the threat landscape.",
        },
        {
          title: "Integrity",
          desc: "We build trust with our students, partners, and employers.",
        },
        {
          title: "Community",
          desc: "We foster a global network of cyber professionals who support each other.",
        },
      ],
      impactTitle: "Global Impact",
      impactStats: [
        { value: "100+", label: "Graduates" },
        { value: "15+", label: "Countries Reached" },
        { value: "90%", label: "Employment Rate" },
        { value: "3mo", label: "Avg. Time to Hire" },
      ],
    },

    certifications: {
      badge: "4-IN-1 PROGRAM",
      title: "The Zero to Hero Certification Path",
      subtitle:
        "Four powerful certifications combined into one comprehensive program.",
      programs: [
        {
          title: "Certified CTI Analyst",
          abbr: "CCTI",
          desc: "Master cyber threat intelligence. Collect, analyze, and act on threat intel.",
          skills: [
            "Threat Hunting",
            "OSINT",
            "Malware Analysis",
            "Threat Modeling",
            "Dark Web Intel",
          ],
        },
        {
          title: "Certified Cybersecurity Analyst",
          abbr: "CCA",
          desc: "Become proficient in analyzing security incidents and implementing defensive strategies.",
          skills: [
            "SIEM",
            "Log Analysis",
            "Incident Response",
            "Vulnerability Assessment",
            "Risk Management",
          ],
        },
        {
          title: "Certified Cybersecurity Associate",
          abbr: "CCA",
          desc: "Build a strong foundation in cybersecurity principles and defensive operations.",
          skills: [
            "Network Security",
            "Cryptography",
            "Firewall",
            "VPN",
            "Security Fundamentals",
          ],
        },
        {
          title: "Certified SOC Analyst",
          abbr: "CSOC",
          desc: "Operate effectively in a Security Operations Center. Monitor, detect, and respond.",
          skills: [
            "SOC Operations",
            "Alert Triage",
            "Threat Detection",
            "Playbook Execution",
            "Reporting",
          ],
        },
      ],
      scheduleTitle: "Learning Pathways",
      fullTime: {
        label: "Full-Time Immersive",
        duration: "3 Months",
        hours: "480 Hours of Elite Training",
        desc: "A high-intensity, deep-dive program to take you from zero to job-ready.",
      },
      partTime: {
        label: "Part-Time Flexible",
        duration: "6 Months",
        hours: "480 Hours Total",
        desc: "The same world-class curriculum distributed over 24 weeks.",
      },
      faqTitle: "Frequently Asked Questions",
      faqs: [
        {
          q: "How do I apply?",
          a: "Click any 'Apply Now' button to connect with our admissions team.",
        },
        {
          q: "What are the fees?",
          a: "Detailed fee information is provided upon inquiry. Contact our admissions office.",
        },
        {
          q: "Do I need IT experience?",
          a: "No. Our program is designed for individuals with no technical background.",
        },
        {
          q: "What happens after graduation?",
          a: "Graduates gain access to career services and the global cyber community.",
        },
      ],
    },

    contact: {
      badge: "GET IN TOUCH",
      title: "Start Your Cyber Journey",
      subtitle:
        "Ready to transform your career? Reach out and our team will get back to you within 24 hours.",
      address: "Kavaja Street, Deliorgj, Tirana 1001, Albania",
      phone: "+355 68 200 8275",
      email: "office@frontspace.io",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        company: "Company / Organization",
        interest: "Program Interest",
        options: [
          { value: "", label: "Select a program..." },
          {
            value: "full-time",
            label: "Full-Time Immersive (3 months)",
          },
          {
            value: "part-time",
            label: "Part-Time Flexible (6 months)",
          },
          { value: "general", label: "General Inquiry" },
        ],
        message: "Your Message",
        submit: "Send Message",
        sending: "Sending...",
        success:
          "Thank you! We'll get back to you within 24 hours.",
        error:
          "Something went wrong. Please try again or email us directly.",
      },
    },

    terms: {
      title: "Terms and Conditions",
      lastUpdated: "Last updated: January 1, 2025",
      sections: [
        {
          title: "1. Acceptance of Terms",
          content:
            "By accessing and using the FrontSpace Cyber Academy website and services, you accept and agree to be bound by these Terms and Conditions.",
        },
        {
          title: "2. Educational Services",
          content:
            "FrontSpace provides cybersecurity training programs, including the Cybersecurity Bootcamp. Enrollment is subject to availability and admission requirements. FrontSpace reserves the right to modify program content, schedules, and pricing with appropriate notice.",
        },
        {
          title: "3. Enrollment and Payment",
          content:
            "Enrollment is confirmed upon receipt of required documentation and payment. Tuition fees must be paid as agreed upon enrollment. FrontSpace's refund policy is provided at enrollment and varies based on program commencement.",
        },
        {
          title: "4. Intellectual Property",
          content:
            "All course materials, curricula, videos, exercises, and content provided by FrontSpace are protected by copyright and intellectual property laws. Students may not reproduce, distribute, or sell these materials without written permission.",
        },
        {
          title: "5. Code of Conduct",
          content:
            "Students are expected to conduct themselves professionally and ethically at all times. Any misuse of cybersecurity knowledge for illegal purposes is strictly prohibited and will result in immediate program termination.",
        },
        {
          title: "6. Certification",
          content:
            "Certifications are awarded upon successful completion of all program requirements, including assessments and practical exercises.",
        },
        {
          title: "7. Limitation of Liability",
          content:
            "FrontSpace is not liable for any indirect, incidental, or consequential damages arising from the use of our services or reliance on our educational content.",
        },
        {
          title: "8. Privacy",
          content:
            "Your privacy is important to us. Personal information collected during enrollment and program participation is handled in accordance with our Privacy Policy and applicable data protection laws.",
        },
        {
          title: "9. Changes to Terms",
          content:
            "FrontSpace reserves the right to modify these Terms and Conditions at any time. Changes will be posted on our website.",
        },
        {
          title: "10. Contact",
          content:
            "For questions about these Terms and Conditions, contact us at office@frontspace.io or Kavaja Street, Deliorgj, Tirana 1001, Albania.",
        },
      ],
    },

    cookies: {
      title: "Cookie Policy",
      lastUpdated: "Last updated: January 1, 2025",
      intro:
        "This Cookie Policy explains how FrontSpace ('we', 'us', or 'our') uses cookies and similar tracking technologies on our website frontspace.io.",
      sections: [
        {
          title: "What Are Cookies?",
          content:
            "Cookies are small text files placed on your device when you visit a website.",
        },
        {
          title: "How We Use Cookies",
          content:
            "We use cookies to: ensure the website functions correctly; analyze site traffic and usage patterns; remember your language preferences; improve user experience.",
        },
        {
          title: "Types of Cookies We Use",
          content:
            "Essential Cookies: Required for the website to function. Analytics Cookies: Help us understand how visitors interact with our website. Preference Cookies: Remember settings like your chosen language.",
        },
        {
          title: "Third-Party Cookies",
          content:
            "We may use third-party services such as Google Analytics that set their own cookies.",
        },
        {
          title: "Managing Cookies",
          content:
            "You can control and delete cookies through your browser settings.",
        },
        {
          title: "Your Consent",
          content:
            "By continuing to use our website, you consent to our use of cookies as described in this policy.",
        },
        {
          title: "Contact Us",
          content:
            "For questions about our Cookie Policy, contact us at office@frontspace.io.",
        },
      ],
    },

    footer: {
      tagline:
        "Helping people and businesses develop skills, build technology, and stay secure in a digital world.",
      companyLinks: "Company",
      legalLinks: "Legal",
      copyright: "© 2025 FrontSpace. All rights reserved.",
      terms: "Terms & Conditions",
      cookies: "Cookie Policy",
      privacy: "Privacy Policy",
    },
  },

  al: {
    nav: {
      home: "Kryefaqja",
      about: "Rreth Nesh",
      mission: "Misioni Yne",
      certifications: "Certifikime",
      news: "Te Rejat",
      contact: "Kontakt",
    },

    news: {
      badge: "LAJMET E FUNDIT",
      title: "Lajme & Perditesime",
      subtitle: "Me te rejat nga FrontSpace Cyber Academy.",
      readMore: "Lexo Me Shume",
      empty: "Ende nuk ka lajme. Kthehuni se shpejti.",
    },

    hero: {
      badge: "AKADEMI KIBERNETIKE ELITE",
      title: "Rrugetimi Juaj",
      titleAccent: "Kibernetik",
      titleEnd: "Fillon Ketu",
      subtitle:
        "Transformohuni nga zero ne profesionist te sigurise kibernetike brenda 3-6 muajve. Trajnim elitar, laboratore reale, certifikime globale.",
      cta: "Aplikoni Tani",
      learnMore: "Meso Me Shume",
      stat1: "480",
      stat1Label: "Ore Trajnimi",
      stat2: "100+",
      stat2Label: "Laboratore",
      stat3: "4",
      stat3Label: "Certifikime",
      stat4: "100%",
      stat4Label: "Gati per Pune",
      scroll: "Levizni Poshte",
    },

    features: {
      badge: "PERSE FRONTSPACE?",
      title: "Ndertuar per Boten Reale",
      subtitle:
        "Zhvilluar rreth metodologjive elitare te trajnimit ushtarak dhe te mesuarit intensiv praktik.",
      items: [
        {
          title: "Program i Pershpejtuar",
          desc: "Kurrikul e drejtuar nga fokusi ne mesimin e aftesive specifike te nevojshme per tregun e punes.",
        },
        {
          title: "Trajnim Praktik",
          desc: "Prioritizoni aftesitë tuaja teknike me mbi 60 laboratore unike dhe 100+ ushtrime te ndryshme.",
        },
        {
          title: "Model i Kombinuar",
          desc: "Me te miren e te mesuarit personalisht dhe ne ritmin tuaj.",
        },
        {
          title: "Sherbime Karriere",
          desc: "Mesoni aftesi thelbësore dhe lidhuni drejtperdrejt me rrjetin global te profesionisteve kibernetike.",
        },
      ],
    },

    tools: {
      badge: "ZOTERO MJETET",
      title: "Zoterim Profesional ne Shkalle Globale",
      subtitle:
        "Fitoni aftesitë teknike te nevojshme per te mbrojtur sistemet kritike ne cdo treg nderkombetar.",
      items: [
        {
          name: "Wireshark",
          desc: "Analize e thelle e paketave per te neutralizuar kercenimet e rrjetit.",
        },
        {
          name: "Python",
          desc: "Ndertoni mjete automatizimi dhe skripte sigurie.",
        },
        {
          name: "Nmap",
          desc: "Hartezim i avancuar i rrjetit dhe zbulim vulnerabilitetesh.",
        },
        {
          name: "Metasploit",
          desc: "Testim penetrimi dhe simulim kercenimesh ne nivel profesional.",
        },
      ],
    },

    syllabus: {
      badge: "PROGRAMI 4-NE-1 NGA ZERO NE HERO",
      title: "PROGRAMI 4-NE-1 NGA ZERO NE HERO",
      desc1:
        "Ky eshte ai—menyra perfundimtare per t'u bere ekspert i sigurise kibernetike. Kemi kombinuar 4 kurse te fuqishme ne 1 program masiv per t'ju dhene gjithcka qe ju nevojitet ne nje vend.",
      desc2:
        "Qofte se jeni fillestar ose deshironi te avanconi, kjo eshte mundesia e madhe qe keni pritur.",
      desc3:
        "Kjo eshte menyra me e shpejte dhe me e fuqishme per te zotëruar fushen dhe per te ndryshuar karrieren tuaj pergjithmone.",
      instruction:
        "KLIKONI 4 MODULET ME POSHTE PER T'I HAPUR DHE PER TE PARE RRUGEN TUAJ TE RE:",
      modules: [
        { name: "ANALIST I CERTIFIKUAR CTI", key: "cti" },
        {
          name: "ANALIST I CERTIFIKUAR I SIGURISE KIBERNETIKE",
          key: "analyst",
        },
        {
          name: "ASOCIAT I CERTIFIKUAR I SIGURISE KIBERNETIKE",
          key: "associate",
        },
        { name: "ANALIST I CERTIFIKUAR SOC", key: "soc" },
      ],
      modalTitle: "Shkarkoni Silabusin",
      modalDesc:
        "Plotesoni te dhenat tuaja per te shkarkuar silabusin.",
      formName: "Emri i Plote",
      formEmail: "Adresa Email",
      formPhone: "Numri i Telefonit",
      formSubmit: "Shkarkoni Silabusin",
      formSending: "Duke derguar...",
      formSuccess: "Silabusi juaj po shkarkohet!",
      formError: "Dicka shkoi keq. Ju lutemi provoni perseri.",
    },

    about: {
      badge: "RRETH FRONTSPACE",
      title: "Porta Juaj drejt Ekselences Kibernetike",
      p1: "Bootcamp-i i Sigurise Kibernetike ne Front Space eshte nje program trajnimi elitar i krijuar posaçerisht per te transformuar individe pa sfond IT ne profesioniste te gatshëm per pune.",
      p2: "Duke shfrytezuar autoritetin global te eksperteve teknike, kurrikula jone jep nivelin e larte te aftesise dhe mendesine taktike te nevojshme per te mbrojtur peizazhet dixhitale moderne.",
      p3: "Ky shtek intensiv mbyll hendekun mes eksperiences zero dhe ekselences profesionale permes metodologjive te provuara.",
      alignedTitle: "Aligned me NIST-NICE",
      alignedDesc: "Kurrikula e hartezuar me Kornizen NICE.",
      salaryTitle: "Paga Fillestare Konkurruese",
      salaryDesc:
        "Profesionistet e sigurise kibernetike jane shume te kerkuar.",
      labsTitle: "100+ Ushtrime Praktike",
      labsDesc:
        "Kaloni kohen tuaj ne laboratore virtuale duke kryer detyra reale sigurie.",
      vetTitle: "Permbajtje e Verifikuar",
      vetDesc:
        "Materialet e kursit rishikohen rregullisht nga eksperte aktive te sigurise.",
      roles: {
        title: "Rolet e Pranueshme pas Diplomimit",
        items: [
          "Analist Sigurie",
          "Analist SOC",
          "Analist CTI",
          "Testues Penetrimi",
          "Pergjigjes Incidentesh",
          "Inxhinier Sigurie",
        ],
      },
    },

    mission: {
      badge: "MISIONI YNE",
      title: "Sigurimi i se Ardhmes Dixhitale",
      subtitle:
        "Ne mbyllim hendekun mes eksperiences zero dhe ekselences profesionale kibernetike",
      visionTitle: "Vizioni Yne",
      visionContent:
        "Te behemi rruga kryesore boterore per individet qe hyjne ne fushen e sigurise kibernetike.",
      missionTitle: "Misioni Yne",
      missionContent:
        "Te demokratizojme aksesin ne arsimin kibernetik me metodologji trajnimi ushtarak elitar per kedo me vullnetin per te mesuar.",
      valuesTitle: "Vlerat Tona Thelbësore",
      values: [
        {
          title: "Ekselence",
          desc: "Ruajme standardet me te larta ne cdo aspekt te programit tone te trajnimit.",
        },
        {
          title: "Inovacion",
          desc: "Kurrikula jone evoluon vazhdimisht me peizazhin e kercenimeve.",
        },
        {
          title: "Integritet",
          desc: "Ndertojme besim me studentet, partneret dhe punedhenesit tona.",
        },
        {
          title: "Komunitet",
          desc: "Nxisim nje rrjet global profesionistesh kibernetike qe mbeshtesin njeri-tjetrin.",
        },
      ],
      impactTitle: "Impakt Global",
      impactStats: [
        { value: "100+", label: "Te Diplomuar" },
        { value: "15+", label: "Vende" },
        { value: "90%", label: "Shkalla e Punesimit" },
        { value: "3muj", label: "Koha Mesatare" },
      ],
    },

    certifications: {
      badge: "PROGRAM 4-NE-1",
      title: "Rruga e Certifikimit Zero deri Heroi",
      subtitle:
        "Kater certifikime te fuqishme te kombinuara ne nje program gjitheperfshires.",
      programs: [
        {
          title: "Analist i Certifikuar CTI",
          abbr: "CCTI",
          desc: "Zotero inteligjencen e kercenimeve kibernetike.",
          skills: [
            "Gjuetia e Kercenimeve",
            "OSINT",
            "Analize Malware",
            "Modelim Kercenimesh",
            "Intel Rrjeti i Erret",
          ],
        },
        {
          title: "Analist i Certifikuar i Sigurise",
          abbr: "CCA",
          desc: "Behuni te afte ne analizimin e incidenteve te sigurise.",
          skills: [
            "SIEM",
            "Analize Regjistrimesh",
            "Reagim Incidentesh",
            "Vleresim Vulnerabilitetesh",
            "Menaxhim Riskut",
          ],
        },
        {
          title: "Asociat i Certifikuar i Sigurise",
          abbr: "CCA",
          desc: "Ndertoni bazament te forte ne parimet e sigurise kibernetike.",
          skills: [
            "Siguria e Rrjetit",
            "Kriptografi",
            "Firewall",
            "VPN",
            "Bazat e Sigurise",
          ],
        },
        {
          title: "Analist i Certifikuar SOC",
          abbr: "CSOC",
          desc: "Operoni ne menyrenefektive ne nje Qender Operacionesh Sigurie.",
          skills: [
            "Operacionet SOC",
            "Triage Alertesh",
            "Zbulim Kercenimesh",
            "Ekzekutim Playbookesh",
            "Raportim",
          ],
        },
      ],
      scheduleTitle: "Rruget e te Mesuarit",
      fullTime: {
        label: "Intensive me Kohe te Plote",
        duration: "3 Muaj",
        hours: "480 Ore Trajnimi Elitar",
        desc: "Program intensiv per t'ju marrë nga zero deri te i gatshem per pune.",
      },
      partTime: {
        label: "Fleksibel me Kohe te Pjesshme",
        duration: "6 Muaj",
        hours: "480 Ore Gjithsej",
        desc: "E njejta kurrikul e shperndarë gjate 24 javeve.",
      },
      faqTitle: "Pyetje te Shpeshta",
      faqs: [
        {
          q: "Si mund te aplikoj?",
          a: "Klikoni cilindo buton 'Apliko Tani' per t'u lidhur me ekipin tone te pranimit.",
        },
        {
          q: "Cilat jane tarifat?",
          a: "Informacioni i detajuar i tarifave jepet pas kerkeses.",
        },
        {
          q: "A kam nevoje per eksperience IT?",
          a: "Jo. Programi yne eshte projektuar per individe pa sfond teknik.",
        },
        {
          q: "Çfare ndodh pas diplomimit?",
          a: "Fitoni akses ne sherbime karriere dhe komunitetin global kibernetik.",
        },
      ],
    },

    contact: {
      badge: "NA KONTAKTONI",
      title: "Filloni Udhetimin Tuaj Kibernetik",
      subtitle:
        "Gati te transformoni karrieren tuaj? Na kontaktoni dhe ekipi yne do t'ju pergjigjet brenda 24 oreve.",
      address: "Rruga Kavaja, Deliorgj, Tirane 1001, Shqiperi",
      phone: "+355 68 200 8275",
      email: "office@frontspace.io",
      form: {
        name: "Emri i Plote",
        email: "Adresa Email",
        phone: "Numri i Telefonit",
        company: "Kompania / Organizata",
        interest: "Interesi per Programin",
        options: [
          {
            value: "",
            label: "Zgjidhni nje program...",
          },
          {
            value: "full-time",
            label: "Intensive (3 muaj)",
          },
          {
            value: "part-time",
            label: "Fleksibel (6 muaj)",
          },
          {
            value: "general",
            label: "Pyetje e Pergjithshme",
          },
        ],
        message: "Mesazhi Juaj",
        submit: "Dergoni Mesazhin",
        sending: "Duke derguar...",
        success:
          "Faleminderit! Do t'ju kontaktojme brenda 24 oreve.",
        error:
          "Dicka shkoi keq. Ju lutemi provoni perseri.",
      },
    },

    terms: {
      title: "Kushtet dhe Rregullat",
      lastUpdated: "Perditesuar se fundmi: 1 Janar 2025",
      sections: [
        {
          title: "1. Pranimi i Kushteve",
          content:
            "Duke aksesuar faqen e FrontSpace, ju pranoni keto Kushte.",
        },
        {
          title: "2. Sherbimet Arsimore",
          content:
            "FrontSpace ofron programe trajnimi kibernetike. Regjistrimi varet nga disponueshmerla.",
        },
        {
          title: "3. Prona Intelektuale",
          content:
            "Te gjitha materialet e kursit jane te mbrojtura me te drejta autori.",
        },
        {
          title: "4. Kodi i Sjelljes",
          content:
            "Keqperdorimi i njohurive kibernetike per qellime te paligjshme eshte rreptesisht i ndaluar.",
        },
        {
          title: "5. Kontakti",
          content:
            "Per pyetje: office@frontspace.io, Rruga Kavaja, Deliorgj, Tirane 1001.",
        },
      ],
    },

    cookies: {
      title: "Politika e Cookies",
      lastUpdated: "Perditesuar se fundmi: 1 Janar 2025",
      intro:
        "Kjo Politike Cookies shpjegon si FrontSpace perdor cookies.",
      sections: [
        {
          title: "Çfare jane Cookies?",
          content:
            "Cookies jane skedare te vegjel teksti te vendosur ne pajisjen tuaj.",
        },
        {
          title: "Si i Perdorim Cookies",
          content:
            "Perdorim cookies per te siguruar funksionimin korrekt te faqes.",
        },
        {
          title: "Llojet e Cookies",
          content:
            "Cookies Thelbésore, Cookies Analitike, Cookies Preferencash.",
        },
        {
          title: "Menaxhimi i Cookies",
          content:
            "Mund te kontrolloni cookies permes cilesimeve te shfletuesit tuaj.",
        },
        {
          title: "Na Kontaktoni",
          content:
            "Per pyetje: office@frontspace.io.",
        },
      ],
    },

    footer: {
      tagline:
        "Transformimi i individeve ne profesioniste elitare te sigurise kibernetike.",
      companyLinks: "Kompania",
      legalLinks: "Juridike",
      copyright:
        "© 2025 FrontSpace. Te gjitha te drejtat te rezervuara.",
      terms: "Kushtet dhe Rregullat",
      cookies: "Politika e Cookies",
      privacy: "Politika e Privatesise",
    },
  },

  it: {
    nav: {
      home: "Home",
      about: "Chi Siamo",
      mission: "La Nostra Missione",
      certifications: "Certificazioni",
      news: "Notizie",
      contact: "Contatti",
    },

    news: {
      badge: "ULTIME NOTIZIE",
      title: "Notizie & Aggiornamenti",
      subtitle: "Le ultime novita da FrontSpace Cyber Academy.",
      readMore: "Leggi di piu",
      empty: "Ancora nessuna notizia. Torna presto.",
    },

    hero: {
      badge: "ACCADEMIA CYBER D'ELITE",
      title: "Il Tuo Percorso",
      titleAccent: "nella Cybersecurity",
      titleEnd: "Inizia Qui",
      subtitle:
        "Da zero a professionista della cybersecurity in 3-6 mesi. Formazione militare d'elite, laboratori reali, certificazioni globali.",
      cta: "Candidati Ora",
      learnMore: "Scopri di Piu",
      stat1: "480",
      stat1Label: "Ore di Formazione",
      stat2: "100+",
      stat2Label: "Laboratori Pratici",
      stat3: "4",
      stat3Label: "Certificazioni",
      stat4: "100%",
      stat4Label: "Pronto al Lavoro",
      scroll: "Scorri in Basso",
    },

    features: {
      badge: "PERCHE FRONTSPACE",
      title: "Costruito per il Mondo Reale",
      subtitle:
        "Sviluppato attorno a metodologie di addestramento militare d'elite e apprendimento pratico intensivo.",
      items: [
        {
          title: "Programma Accelerato",
          desc: "Curriculum mirato a insegnare le competenze specifiche richieste dal mercato del lavoro.",
        },
        {
          title: "Formazione Pratica",
          desc: "Priorita alle competenze tecniche con oltre 60 laboratori unici e 100+ esercitazioni.",
        },
        {
          title: "Modello Misto",
          desc: "Il meglio dell'apprendimento in presenza e autonomo. I facilitatori supportano l'intero percorso.",
        },
        {
          title: "Servizi di Carriera",
          desc: "Impara competenze trasversali essenziali e connettiti alla rete globale di professionisti cyber.",
        },
      ],
    },

    tools: {
      badge: "PADRONEGGIA GLI STRUMENTI",
      title: "Padronanza Professionale su Scala Globale",
      subtitle:
        "Acquisisci le competenze tecniche necessarie per proteggere sistemi critici in qualsiasi mercato internazionale.",
      items: [
        {
          name: "Wireshark",
          desc: "Analisi profonda dei pacchetti per intercettare e neutralizzare le minacce di rete.",
        },
        {
          name: "Python",
          desc: "Crea strumenti di automazione personalizzati e script di sicurezza.",
        },
        {
          name: "Nmap",
          desc: "Mappatura avanzata della rete e scoperta delle vulnerabilita.",
        },
        {
          name: "Metasploit",
          desc: "Test di penetrazione professionale e simulazione di minacce.",
        },
      ],
    },

    syllabus: {
      badge: "IL PROGRAMMA 4-IN-1 DA ZERO A EROE",
      title: "IL PROGRAMMA 4-IN-1 DA ZERO A EROE",
      desc1:
        "Ecco il modo definitivo per diventare un esperto di cybersecurity. Abbiamo combinato 4 corsi potenti in 1 programma massiccio per darti tutto cio di cui hai bisogno in un unico posto.",
      desc2:
        "Che tu sia un principiante assoluto o voglia salire di livello, questa e l'opportunita che stavi aspettando.",
      desc3:
        "Questo e il modo piu veloce e potente per padroneggiare il settore e cambiare la tua carriera per sempre.",
      instruction:
        "CLICCA SUI 4 MODULI QUI SOTTO PER SCOPRIRE IL TUO NUOVO PERCORSO:",
      modules: [
        { name: "ANALISTA CTI CERTIFICATO", key: "cti" },
        {
          name: "ANALISTA CYBERSECURITY CERTIFICATO",
          key: "analyst",
        },
        {
          name: "ASSOCIATO CYBERSECURITY CERTIFICATO",
          key: "associate",
        },
        { name: "ANALISTA SOC CERTIFICATO", key: "soc" },
      ],
      modalTitle: "Scarica il Syllabus",
      modalDesc:
        "Inserisci i tuoi dati per scaricare il syllabus.",
      formName: "Nome Completo",
      formEmail: "Indirizzo Email",
      formPhone: "Numero di Telefono",
      formSubmit: "Scarica il Syllabus",
      formSending: "Invio in corso...",
      formSuccess: "Il tuo syllabus si sta scaricando!",
      formError: "Qualcosa e andato storto. Riprova.",
    },

    about: {
      badge: "CHI E FRONTSPACE",
      title: "La Tua Porta verso l'Eccellenza Cyber",
      p1: "Il Bootcamp di Cybersecurity di Front Space e un programma di formazione d'elite progettato per trasformare individui senza esperienza IT in professionisti pronti al lavoro.",
      p2: "Sfruttando l'autorita globale dei migliori esperti tecnici, il nostro curriculum fornisce competenze avanzate e mentalita tattica per difendere i paesaggi digitali moderni.",
      p3: "Questo percorso intensivo colma il divario tra zero esperienza ed eccellenza professionale.",
      alignedTitle: "Allineato con NIST-NICE",
      alignedDesc:
        "Curriculum mappato al Framework NICE — lo standard globale del settore.",
      salaryTitle: "Stipendio Iniziale Competitivo",
      salaryDesc:
        "I professionisti della cybersecurity sono molto richiesti.",
      labsTitle: "100+ Esercitazioni Pratiche",
      labsDesc:
        "Trascorri la maggior parte del tempo in laboratori virtuali.",
      vetTitle: "Contenuti Verificati dal Settore",
      vetDesc:
        "I materiali del corso sono regolarmente revisionati da esperti di sicurezza attivi.",
      roles: {
        title: "Ruoli Idonei dopo il Diploma",
        items: [
          "Analista di Sicurezza",
          "Analista SOC",
          "Analista CTI",
          "Tester di Penetrazione",
          "Risposta agli Incidenti",
          "Ingegnere della Sicurezza",
        ],
      },
    },

    mission: {
      badge: "LA NOSTRA MISSIONE",
      title: "Proteggere il Futuro Digitale",
      subtitle:
        "Colmiamo il divario tra zero esperienza ed eccellenza professionale nella cybersecurity",
      visionTitle: "La Nostra Visione",
      visionContent:
        "Diventare il percorso leader mondiale per chi entra nel campo della cybersecurity.",
      missionTitle: "La Nostra Missione",
      missionContent:
        "Democratizzare l'accesso all'educazione cyber con metodologie di formazione militare d'elite per chiunque voglia imparare.",
      valuesTitle: "Valori Fondamentali",
      values: [
        {
          title: "Eccellenza",
          desc: "Manteniamo gli standard piu alti in ogni aspetto del nostro programma.",
        },
        {
          title: "Innovazione",
          desc: "Il nostro curriculum si evolve continuamente con il panorama delle minacce.",
        },
        {
          title: "Integrita",
          desc: "Costruiamo fiducia con studenti, partner e datori di lavoro.",
        },
        {
          title: "Comunita",
          desc: "Promuoviamo una rete globale di professionisti cyber che si supportano a vicenda.",
        },
      ],
      impactTitle: "Impatto Globale",
      impactStats: [
        { value: "100+", label: "Diplomati" },
        { value: "15+", label: "Paesi Raggiunti" },
        { value: "90%", label: "Tasso di Occupazione" },
        { value: "3 mesi", label: "Tempo Medio" },
      ],
    },

    certifications: {
      badge: "PROGRAMMA 4-IN-1",
      title: "Il Percorso di Certificazione Da Zero a Eroe",
      subtitle:
        "Quattro potenti certificazioni combinate in un unico programma completo.",
      programs: [
        {
          title: "Analista CTI Certificato",
          abbr: "CCTI",
          desc: "Padroneggia l'intelligence sulle minacce cyber.",
          skills: [
            "Threat Hunting",
            "OSINT",
            "Analisi Malware",
            "Modellazione Minacce",
            "Intel Dark Web",
          ],
        },
        {
          title: "Analista Cybersecurity Certificato",
          abbr: "CCA",
          desc: "Diventa esperto nell'analisi degli incidenti di sicurezza.",
          skills: [
            "SIEM",
            "Analisi Log",
            "Risposta Incidenti",
            "Valutazione Vulnerabilita",
            "Gestione Rischi",
          ],
        },
        {
          title: "Associato Cybersecurity Certificato",
          abbr: "CCA",
          desc: "Costruisci solide basi nei principi della cybersecurity.",
          skills: [
            "Sicurezza Rete",
            "Crittografia",
            "Firewall",
            "VPN",
            "Fondamenti Sicurezza",
          ],
        },
        {
          title: "Analista SOC Certificato",
          abbr: "CSOC",
          desc: "Opera efficacemente in un Centro Operativo di Sicurezza.",
          skills: [
            "Operazioni SOC",
            "Triage Alert",
            "Rilevamento Minacce",
            "Esecuzione Playbook",
            "Reporting",
          ],
        },
      ],
      scheduleTitle: "Percorsi di Apprendimento",
      fullTime: {
        label: "Full-Time Intensivo",
        duration: "3 Mesi",
        hours: "480 Ore di Formazione Elite",
        desc: "Programma intensivo da zero a pronto al lavoro.",
      },
      partTime: {
        label: "Part-Time Flessibile",
        duration: "6 Mesi",
        hours: "480 Ore Totali",
        desc: "Lo stesso curriculum distribuito su 24 settimane.",
      },
      faqTitle: "Domande Frequenti",
      faqs: [
        {
          q: "Come mi candido?",
          a: "Clicca qualsiasi pulsante 'Candidati Ora' per contattare il team ammissioni.",
        },
        {
          q: "Quali sono i costi?",
          a: "Le informazioni dettagliate sui costi vengono fornite su richiesta.",
        },
        {
          q: "Serve esperienza IT?",
          a: "No. Il nostro programma e progettato per persone senza background tecnico.",
        },
        {
          q: "Cosa succede dopo il diploma?",
          a: "I diplomati ottengono accesso ai servizi di carriera e alla comunita cyber globale.",
        },
      ],
    },

    contact: {
      badge: "CONTATTACI",
      title: "Inizia il Tuo Percorso Cyber",
      subtitle:
        "Pronto a trasformare la tua carriera? Contattaci e il nostro team ti rispondera entro 24 ore.",
      address: "Via Kavaja, Deliorgj, Tirana 1001, Albania",
      phone: "+355 68 200 8275",
      email: "office@frontspace.io",
      form: {
        name: "Nome Completo",
        email: "Indirizzo Email",
        phone: "Numero di Telefono",
        company: "Azienda / Organizzazione",
        interest: "Interesse per il Programma",
        options: [
          {
            value: "",
            label: "Seleziona un programma...",
          },
          {
            value: "full-time",
            label: "Full-Time Intensivo (3 mesi)",
          },
          {
            value: "part-time",
            label: "Part-Time Flessibile (6 mesi)",
          },
          {
            value: "general",
            label: "Richiesta Generica",
          },
        ],
        message: "Il Tuo Messaggio",
        submit: "Invia Messaggio",
        sending: "Invio...",
        success:
          "Grazie! Ti contatteremo entro 24 ore.",
        error:
          "Qualcosa e andato storto. Riprova.",
      },
    },

    terms: {
      title: "Termini e Condizioni",
      lastUpdated: "Ultimo aggiornamento: 1 Gennaio 2025",
      sections: [
        {
          title: "1. Accettazione dei Termini",
          content:
            "Accedendo al sito web di FrontSpace, accetti questi Termini e Condizioni.",
        },
        {
          title: "2. Servizi Educativi",
          content:
            "FrontSpace fornisce programmi di formazione in cybersecurity.",
        },
        {
          title: "3. Proprieta Intellettuale",
          content:
            "Tutti i materiali del corso sono protetti da diritto d'autore.",
        },
        {
          title: "4. Codice di Condotta",
          content:
            "L'uso improprio delle conoscenze cyber per scopi illegali e severamente vietato.",
        },
        {
          title: "5. Contatti",
          content:
            "Per domande: office@frontspace.io, Via Kavaja, Deliorgj, Tirana 1001.",
        },
      ],
    },

    cookies: {
      title: "Politica dei Cookie",
      lastUpdated: "Ultimo aggiornamento: 1 Gennaio 2025",
      intro:
        "Questa Politica dei Cookie spiega come FrontSpace utilizza i cookie.",
      sections: [
        {
          title: "Cosa sono i Cookie?",
          content:
            "I cookie sono piccoli file di testo inseriti sul tuo dispositivo.",
        },
        {
          title: "Come Utilizziamo i Cookie",
          content:
            "Utilizziamo i cookie per garantire il funzionamento del sito e analizzare il traffico.",
        },
        {
          title: "Tipi di Cookie",
          content:
            "Cookie Essenziali, Cookie Analitici, Cookie di Preferenza.",
        },
        {
          title: "Gestione dei Cookie",
          content:
            "Puoi controllare i cookie tramite le impostazioni del browser.",
        },
        {
          title: "Contattaci",
          content:
            "Per domande: office@frontspace.io.",
        },
      ],
    },

    footer: {
      tagline:
        "Trasformare individui in professionisti d'elite della cybersecurity.",
      companyLinks: "Azienda",
      legalLinks: "Legale",
      copyright:
        "© 2025 FrontSpace. Tutti i diritti riservati.",
      terms: "Termini e Condizioni",
      cookies: "Politica dei Cookie",
      privacy: "Politica sulla Privacy",
    },
  },

  es: {
    nav: {
      home: "Inicio",
      about: "Sobre Nosotros",
      mission: "Nuestra Mision",
      certifications: "Certificaciones",
      news: "Noticias",
      contact: "Contacto",
    },

    news: {
      badge: "ULTIMAS NOTICIAS",
      title: "Noticias & Novedades",
      subtitle: "Lo ultimo de FrontSpace Cyber Academy.",
      readMore: "Leer Mas",
      empty: "Aun no hay noticias. Vuelve pronto.",
    },

    hero: {
      badge: "ACADEMIA CYBER DE ELITE",
      title: "Tu Camino en",
      titleAccent: "Ciberseguridad",
      titleEnd: "Comienza Aqui",
      subtitle:
        "De cero a profesional de ciberseguridad en 3-6 meses. Formacion militar de elite, laboratorios reales, certificaciones globales.",
      cta: "Aplicar Ahora",
      learnMore: "Saber Mas",
      stat1: "480",
      stat1Label: "Horas de Formacion",
      stat2: "100+",
      stat2Label: "Laboratorios",
      stat3: "4",
      stat3Label: "Certificaciones",
      stat4: "100%",
      stat4Label: "Listo para Trabajar",
      scroll: "Desplazar Abajo",
    },

    features: {
      badge: "POR QUE FRONTSPACE",
      title: "Construido para el Mundo Real",
      subtitle:
        "Desarrollado en torno a metodologias de entrenamiento militar de elite y aprendizaje practico intensivo.",
      items: [
        {
          title: "Programa Acelerado",
          desc: "Curriculo enfocado en ensenar las habilidades especificas que necesitas para el mercado laboral.",
        },
        {
          title: "Formacion Practica",
          desc: "Prioriza tus habilidades tecnicas con mas de 60 laboratorios unicos y 100+ ejercicios.",
        },
        {
          title: "Modelo Combinado",
          desc: "Lo mejor del aprendizaje presencial y autonomo. Los facilitadores apoyan todo tu recorrido.",
        },
        {
          title: "Servicios de Carrera",
          desc: "Aprende habilidades blandas esenciales y conectate a la red global de profesionales cyber.",
        },
      ],
    },

    tools: {
      badge: "DOMINA LAS HERRAMIENTAS",
      title: "Dominio Profesional a Escala Global",
      subtitle:
        "Adquiere las habilidades tecnicas necesarias para proteger sistemas criticos en cualquier mercado internacional.",
      items: [
        {
          name: "Wireshark",
          desc: "Analisis profundo de paquetes para interceptar y neutralizar amenazas de red.",
        },
        {
          name: "Python",
          desc: "Crea herramientas de automatizacion personalizadas y scripts de seguridad.",
        },
        {
          name: "Nmap",
          desc: "Mapeo avanzado de redes y descubrimiento de vulnerabilidades.",
        },
        {
          name: "Metasploit",
          desc: "Pruebas de penetracion profesionales y simulacion de amenazas.",
        },
      ],
    },

    syllabus: {
      badge: "EL PROGRAMA 4-EN-1 DE CERO A HEROE",
      title: "EL PROGRAMA 4-EN-1 DE CERO A HEROE",
      desc1:
        "Esta es la forma definitiva de convertirte en un experto en ciberseguridad. Hemos combinado 4 cursos poderosos en 1 programa masivo para darte todo lo que necesitas en un solo lugar.",
      desc2:
        "Ya seas un principiante total o quieras subir de nivel, esta es la gran oportunidad que estabas esperando.",
      desc3:
        "Esta es la forma mas rapida y poderosa de dominar el campo y cambiar tu carrera para siempre.",
      instruction:
        "HAZ CLIC EN LOS 4 MODULOS A CONTINUACION PARA DESCUBRIR TU NUEVO CAMINO:",
      modules: [
        { name: "ANALISTA CTI CERTIFICADO", key: "cti" },
        {
          name: "ANALISTA DE CIBERSEGURIDAD CERTIFICADO",
          key: "analyst",
        },
        {
          name: "ASOCIADO DE CIBERSEGURIDAD CERTIFICADO",
          key: "associate",
        },
        { name: "ANALISTA SOC CERTIFICADO", key: "soc" },
      ],
      modalTitle: "Descargar Syllabus",
      modalDesc:
        "Completa tus datos para descargar el syllabus.",
      formName: "Nombre Completo",
      formEmail: "Correo Electronico",
      formPhone: "Numero de Telefono",
      formSubmit: "Descargar Syllabus",
      formSending: "Enviando...",
      formSuccess: "Tu syllabus se esta descargando!",
      formError: "Algo salio mal. Intentalo de nuevo.",
    },

    about: {
      badge: "SOBRE FRONTSPACE",
      title: "Tu Puerta a la Excelencia Cyber",
      p1: "El Bootcamp de Ciberseguridad en Front Space es un programa de formacion de elite disenado para transformar individuos sin experiencia IT en profesionales listos para trabajar.",
      p2: "Aprovechando la autoridad global de expertos tecnicos de primer nivel, nuestro curriculo proporciona competencias avanzadas y mentalidad tactica para defender los paisajes digitales modernos.",
      p3: "Este camino intensivo cierra la brecha entre cero experiencia y la excelencia profesional.",
      alignedTitle: "Alineado con NIST-NICE",
      alignedDesc:
        "Curriculo mapeado al Framework NICE — el estandar global de la industria.",
      salaryTitle: "Salario Inicial Competitivo",
      salaryDesc:
        "Los profesionales de ciberseguridad son muy demandados.",
      labsTitle: "100+ Ejercicios Practicos",
      labsDesc:
        "Pasa la mayor parte del tiempo en laboratorios virtuales.",
      vetTitle: "Contenido Verificado por la Industria",
      vetDesc:
        "El material del curso es revisado regularmente por expertos de seguridad activos.",
      roles: {
        title: "Roles Elegibles tras la Graduacion",
        items: [
          "Analista de Seguridad",
          "Analista SOC",
          "Analista CTI",
          "Tester de Penetracion",
          "Respuesta a Incidentes",
          "Ingeniero de Seguridad",
        ],
      },
    },

    mission: {
      badge: "NUESTRA MISION",
      title: "Asegurando el Futuro Digital",
      subtitle:
        "Cerramos la brecha entre cero experiencia y la excelencia profesional en ciberseguridad",
      visionTitle: "Nuestra Vision",
      visionContent:
        "Convertirnos en la ruta lider mundial para quienes ingresan al campo de la ciberseguridad.",
      missionTitle: "Nuestra Mision",
      missionContent:
        "Democratizar el acceso a la educacion cyber con metodologias de formacion militar de elite para cualquiera con voluntad de aprender.",
      valuesTitle: "Valores Fundamentales",
      values: [
        {
          title: "Excelencia",
          desc: "Mantenemos los mas altos estandares en cada aspecto de nuestro programa.",
        },
        {
          title: "Innovacion",
          desc: "Nuestro curriculo evoluciona continuamente con el panorama de amenazas.",
        },
        {
          title: "Integridad",
          desc: "Construimos confianza con estudiantes, socios y empleadores.",
        },
        {
          title: "Comunidad",
          desc: "Fomentamos una red global de profesionales cyber que se apoyan mutuamente.",
        },
      ],
      impactTitle: "Impacto Global",
      impactStats: [
        { value: "100+", label: "Graduados" },
        { value: "15+", label: "Paises Alcanzados" },
        { value: "90%", label: "Tasa de Empleo" },
        { value: "3 meses", label: "Tiempo Promedio" },
      ],
    },

    certifications: {
      badge: "PROGRAMA 4-EN-1",
      title: "El Camino de Certificacion de Cero a Heroe",
      subtitle:
        "Cuatro certificaciones poderosas combinadas en un programa integral.",
      programs: [
        {
          title: "Analista CTI Certificado",
          abbr: "CCTI",
          desc: "Domina la inteligencia de amenazas ciberneticas.",
          skills: [
            "Caza de Amenazas",
            "OSINT",
            "Analisis Malware",
            "Modelado de Amenazas",
            "Intel Dark Web",
          ],
        },
        {
          title: "Analista de Ciberseguridad Certificado",
          abbr: "CCA",
          desc: "Especialista en analisis de incidentes de seguridad.",
          skills: [
            "SIEM",
            "Analisis de Logs",
            "Respuesta a Incidentes",
            "Evaluacion de Vulnerabilidades",
            "Gestion de Riesgos",
          ],
        },
        {
          title: "Asociado de Ciberseguridad Certificado",
          abbr: "CCA",
          desc: "Construye bases solidas en principios de ciberseguridad.",
          skills: [
            "Seguridad de Red",
            "Criptografia",
            "Firewall",
            "VPN",
            "Fundamentos de Seguridad",
          ],
        },
        {
          title: "Analista SOC Certificado",
          abbr: "CSOC",
          desc: "Opera eficazmente en un Centro de Operaciones de Seguridad.",
          skills: [
            "Operaciones SOC",
            "Triaje de Alertas",
            "Deteccion de Amenazas",
            "Ejecucion de Playbooks",
            "Reportes",
          ],
        },
      ],
      scheduleTitle: "Rutas de Aprendizaje",
      fullTime: {
        label: "Tiempo Completo Intensivo",
        duration: "3 Meses",
        hours: "480 Horas de Formacion Elite",
        desc: "Programa intensivo de cero a listo para trabajar.",
      },
      partTime: {
        label: "Medio Tiempo Flexible",
        duration: "6 Meses",
        hours: "480 Horas Totales",
        desc: "El mismo curriculo distribuido en 24 semanas.",
      },
      faqTitle: "Preguntas Frecuentes",
      faqs: [
        {
          q: "Como aplico?",
          a: "Haz clic en cualquier boton 'Aplicar Ahora' para contactar a nuestro equipo de admisiones.",
        },
        {
          q: "Cuales son los costos?",
          a: "La informacion detallada de costos se proporciona bajo solicitud.",
        },
        {
          q: "Necesito experiencia IT?",
          a: "No. Nuestro programa esta disenado para personas sin experiencia tecnica.",
        },
        {
          q: "Que pasa despues de graduarme?",
          a: "Los graduados obtienen acceso a servicios de carrera y la comunidad cyber global.",
        },
      ],
    },

    contact: {
      badge: "CONTACTANOS",
      title: "Inicia Tu Camino Cyber",
      subtitle:
        "Listo para transformar tu carrera? Contactanos y nuestro equipo te respondera en 24 horas.",
      address: "Calle Kavaja, Deliorgj, Tirana 1001, Albania",
      phone: "+355 68 200 8275",
      email: "office@frontspace.io",
      form: {
        name: "Nombre Completo",
        email: "Correo Electronico",
        phone: "Numero de Telefono",
        company: "Empresa / Organizacion",
        interest: "Interes en el Programa",
        options: [
          {
            value: "",
            label: "Selecciona un programa...",
          },
          {
            value: "full-time",
            label: "Tiempo Completo (3 meses)",
          },
          {
            value: "part-time",
            label: "Medio Tiempo (6 meses)",
          },
          {
            value: "general",
            label: "Consulta General",
          },
        ],
        message: "Tu Mensaje",
        submit: "Enviar Mensaje",
        sending: "Enviando...",
        success:
          "Gracias! Te contactaremos en 24 horas.",
        error:
          "Algo salio mal. Intentalo de nuevo.",
      },
    },

    terms: {
      title: "Terminos y Condiciones",
      lastUpdated: "Ultima actualizacion: 1 de Enero de 2025",
      sections: [
        {
          title: "1. Aceptacion de Terminos",
          content:
            "Al acceder al sitio web de FrontSpace, aceptas estos Terminos y Condiciones.",
        },
        {
          title: "2. Servicios Educativos",
          content:
            "FrontSpace proporciona programas de formacion en ciberseguridad.",
        },
        {
          title: "3. Propiedad Intelectual",
          content:
            "Todos los materiales del curso estan protegidos por derechos de autor.",
        },
        {
          title: "4. Codigo de Conducta",
          content:
            "El uso indebido del conocimiento cyber para fines ilegales esta estrictamente prohibido.",
        },
        {
          title: "5. Contacto",
          content:
            "Para preguntas: office@frontspace.io, Calle Kavaja, Deliorgj, Tirana 1001.",
        },
      ],
    },

    cookies: {
      title: "Politica de Cookies",
      lastUpdated: "Ultima actualizacion: 1 de Enero de 2025",
      intro:
        "Esta Politica de Cookies explica como FrontSpace utiliza cookies.",
      sections: [
        {
          title: "Que son las Cookies?",
          content:
            "Las cookies son pequenos archivos de texto colocados en tu dispositivo.",
        },
        {
          title: "Como Usamos las Cookies",
          content:
            "Usamos cookies para garantizar el funcionamiento del sitio y analizar el trafico.",
        },
        {
          title: "Tipos de Cookies",
          content:
            "Cookies Esenciales, Cookies Analiticas, Cookies de Preferencia.",
        },
        {
          title: "Gestion de Cookies",
          content:
            "Puedes controlar las cookies a traves de la configuracion de tu navegador.",
        },
        {
          title: "Contactanos",
          content:
            "Para preguntas: office@frontspace.io.",
        },
      ],
    },

    footer: {
      tagline:
        "Transformando individuos en profesionales de ciberseguridad de elite.",
      companyLinks: "Empresa",
      legalLinks: "Legal",
      copyright:
        "© 2025 FrontSpace. Todos los derechos reservados.",
      terms: "Terminos y Condiciones",
      cookies: "Politica de Cookies",
      privacy: "Politica de Privacidad",
    },
  },
};

